<template>
  <v-app>
    <component :is="layout">
    </component>
  </v-app>
</template>

<script setup>
import { useAppStore } from '@/stores/app'
import DefaultLayout from '@/pseudo-layouts/default-layout'
import FullScreenLayout from '@/pseudo-layouts/full-screen-layout.vue'
const appStore = useAppStore(),
  route = useRoute(),
  router = useRouter(),
  watchUrls = ref(false)

onMounted(async () => {
  // // First, navigate to the correct path if necessary
  // appStore.navigateToProperRoute()

  // Then start loader after each route (but not for pagination query parameter changes)
  router.afterEach((to, from) => {
    // Don't trigger global loader for query-only changes (pagination)
    if (to.path === from.path) {
      return
    }
    appStore.startLoader()
  })

  appStore.initToken()
})

watch(() => router.currentRoute.value.path, (newPath) => {
  appStore.navigateToProperRoute()
  appStore.processUpdateUrls()
})

const layout = computed(() => {
  if (route.path.startsWith('/pages/new')) {
    appStore.endLoader()
    return FullScreenLayout
  } else {
    appStore.endLoader()
    return DefaultLayout
  }
})

</script>

<style lang="scss">
  @import '@/assets/scss/global.scss';
</style>
